module.exports = __webpack_public_path__ + "img/ware2.ce8ac6c0.png";